import React from 'react';

function EveningIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="330.391" height="330.127" viewBox="0 0 330.391 330.127">
      <path
        id="Path_3953"
        data-name="Path 3953"
        d="M324.91,187.318a14.81,14.81,0,0,0-18.437,2.783A114.681,114.681,0,0,1,211.855,223.5c-51.832-5.914-93.923-48.005-99.837-99.837A112.535,112.535,0,0,1,145.413,29.04,14.877,14.877,0,0,0,148.2,10.6,15.63,15.63,0,0,0,131.15,2.95,166.392,166.392,0,0,0,2.788,174.447C6.963,258.63,76.536,328.2,160.719,332.377c3.131,0,5.914.348,9.044.348a167.386,167.386,0,0,0,162.8-128.362C333.955,197.406,331.172,190.449,324.91,187.318Z"
        transform="translate(-2.524 -2.599)"
        fill="#717171"
      />
    </svg>
  );
}

export default EveningIcon;
